export default __webpack_public_path__ + "static/titian_cernicova_dragomir-a12f9c9ec0174bc706ded583cded7a10.png";